import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('div', 'modalFooter', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    margin: '10px 0 0 0',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalFooter.tsx